const permissions = [
  { id: 1, code: 'dashboard.view', name: '查看概览', module: 'dashboard', is_platform: 0 },
  { id: 2, code: 'stores.view', name: '查看团队', module: 'stores', is_platform: 1 },
  { id: 3, code: 'stores.create', name: '创建团队', module: 'stores', is_platform: 1 },
  { id: 4, code: 'stores.update', name: '编辑团队', module: 'stores', is_platform: 1 },
  { id: 5, code: 'stores.delete', name: '删除团队', module: 'stores', is_platform: 1 },
  { id: 6, code: 'users.view', name: '查看账号', module: 'users', is_platform: 0 },
  { id: 7, code: 'users.create', name: '创建账号', module: 'users', is_platform: 0 },
  { id: 8, code: 'users.update', name: '编辑账号', module: 'users', is_platform: 0 },
  { id: 9, code: 'users.delete', name: '删除账号', module: 'users', is_platform: 0 },
  { id: 10, code: 'roles.view', name: '查看角色', module: 'roles', is_platform: 0 },
  { id: 11, code: 'roles.create', name: '创建角色', module: 'roles', is_platform: 0 },
  { id: 12, code: 'roles.update', name: '编辑角色', module: 'roles', is_platform: 0 },
  { id: 13, code: 'roles.delete', name: '删除角色', module: 'roles', is_platform: 0 },
  { id: 14, code: 'ai.settings.view', name: '查看AI设置', module: 'ai', is_platform: 1 },
  { id: 15, code: 'ai.settings.update', name: '修改AI设置', module: 'ai', is_platform: 1 },
  { id: 16, code: 'storage.settings.view', name: '查看对象存储设置', module: 'storage', is_platform: 1 },
  { id: 17, code: 'storage.settings.update', name: '修改对象存储设置', module: 'storage', is_platform: 1 }
];
const stores = [{ id: 1, name: '演示旗舰团队', status: 1, admin_user_id: 1, admin_username: 'demo-owner', admin_display_name: '演示店长', account_count: 2, logo: '' }];
const roles = [{ id: 1, store_id: 1, store_name: '演示旗舰团队', name: '团队客服', code: 'support', description: '查看团队账号与概览', permissions: ['dashboard.view', 'users.view'], user_count: 1 }];
const users = [
  { id: 1, store_id: 1, store_name: '演示旗舰团队', username: 'demo-owner', display_name: '演示店长', status: 1, is_store_admin: 1, is_super_admin: 0, roles: [], permissions: permissions.filter((permission) => !permission.is_platform).map((permission) => permission.code) },
  { id: 2, store_id: 1, store_name: '演示旗舰团队', username: 'demo-support', display_name: '演示客服', status: 1, is_store_admin: 0, is_super_admin: 0, roles, permissions: ['dashboard.view', 'users.view'] }
];
export default {
  actor: { id: 999, username: 'demo-admin', display_name: '演示管理员', roles: [], permissions: permissions.map((permission) => permission.code), is_super_admin: true },
  dashboard: { scope: 'platform', stores: 1, users: 2, active_users: 2, roles: 1, distribution: [{ name: '演示旗舰团队', value: 2 }], role_distribution: [{ name: '团队客服', value: 1 }], store_list: stores, accounts: users },
  stores: { items: stores, total: stores.length, page: 1, per_page: 20 },
  users: { items: users, total: users.length, page: 1, per_page: 20 },
  roles,
  permissions,
  aiSettings: { enabled: false, token_limit: 500000, model: 'doubao-seed-2-1-pro-260915' },
  aiUsage: [],
  storageSettings: { enabled: true, default_quota_gb: 5 },
  storageUsage: []
};


